import { BUFFER_MARGIN } from 'automation-ui-flow-core/canvas/graphConstants';
const shouldGoToPathRender = ({
  path: {
    bounds: {
      minX,
      maxX,
      minY,
      maxY
    }
  },
  bufferMargin = BUFFER_MARGIN,
  zoomLevel,
  scrollElementClientRect: {
    width,
    height
  },
  canvasLeftScroll,
  canvasTopScroll
}) => {
  return !(maxX < (canvasLeftScroll - width - bufferMargin) / zoomLevel || minX > (canvasLeftScroll + width + bufferMargin) / zoomLevel || maxY < (canvasTopScroll - height - bufferMargin) / zoomLevel || minY > (canvasTopScroll + height + bufferMargin) / zoomLevel);
};
export default shouldGoToPathRender;